import React from 'react';
import { AdjustmentBucket } from 'model/salesDashboard';
import { AdjustmentBucketChart } from '../Common/AdjustmentBucketChart';

interface ChargebacksChartProps {
    data?: AdjustmentBucket;
    isLoading?: boolean;
}

export const ChargebacksChart: React.FC<ChargebacksChartProps> = ({ data, isLoading }) => (
    <AdjustmentBucketChart
        data={data}
        isLoading={isLoading}
        title="Chargebacks"
    />
);
